import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Heading,
  Text,
  Card,
  Flex,
  Button,
  TextField,
  TextArea,
} from '@radix-ui/themes';
import { IdCardIcon } from '@radix-ui/react-icons';

const EntityCreate: React.FC = () => {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [location, setLocation] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (!name.trim()) {
      setError('Name is required');
      return;
    }

    setLoading(true);
    try {
      // TODO: Implement createEntity mutation once backend supports it
      // For now, show an informational message
      setError(
        'Entity creation is currently managed by the system through OFAC data imports. Manual entity creation will be available soon.',
      );
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to create entity');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/entities');
  };

  return (
    <Box>
      <Box pb="4" px="1">
        <Flex align="center" gap="3">
          <Box
            style={{
              padding: '8px',
              borderRadius: '8px',
              backgroundColor: 'var(--purple-3)',
              color: 'var(--purple-11)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <IdCardIcon width={24} height={24} />
          </Box>
          <Box>
            <Heading as="h1" size="5" weight="bold">
              Create Entity
            </Heading>
            <Text size="2" color="gray">
              Add a new entity to track addresses
            </Text>
          </Box>
        </Flex>
      </Box>

      <Card size="3">
        <form onSubmit={handleSubmit}>
          <Flex direction="column" gap="4">
            <Box>
              <Text as="label" size="2" weight="medium" mb="2">
                Name
              </Text>
              <TextField.Root
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter entity name"
                required
              />
            </Box>

            <Box>
              <Text as="label" size="2" weight="medium" mb="2">
                Location
              </Text>
              <TextArea
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                placeholder="Enter location (optional)"
                rows={3}
              />
            </Box>

            {error && (
              <Box
                p="3"
                style={{
                  backgroundColor: 'var(--red-3)',
                  borderRadius: '6px',
                }}
              >
                <Text size="2" color="red">
                  {error}
                </Text>
              </Box>
            )}

            <Flex gap="3" justify="end">
              <Button
                type="button"
                variant="soft"
                color="gray"
                onClick={handleCancel}
              >
                Cancel
              </Button>
              <Button type="submit" disabled={loading}>
                {loading ? 'Creating...' : 'Create Entity'}
              </Button>
            </Flex>
          </Flex>
        </form>
      </Card>
    </Box>
  );
};

export default EntityCreate;
